const getters = {
  activeDevicesNum: state => state.activeDevicesNum,
  activeUsersNum: state => state.activeUsersNum,
  admins: state => state.admins,
  companies: state => state.companies,
  devices: state => state.devices,
  deviceUsage: state => state.deviceUsage,
  deviceUsageNum: state => state.deviceUsageNum,
  endDate: state => state.endDate,
  isLoading: state => state.isLoading,
  numDates: state => state.numDates,
  promotions: state => state.promotions,
  startDate: state => state.startDate
}

export default getters
